
// Plan shopping for selfserve clients (#656 cutover). /checkup was fullserve-only
// until the isFullserve gate came off, and selfserve clients had no equivalent
// of /survey/plans — the one step that is the whole point of self-service.
export default {
    computed: {
        year () { return this.$store.getters.year },
    },
}
